export const Validators = {
    email,
    phone,
    name,
    password,
    loginID,
    fullName,
    positiveIntegerNumber,
    pin,
    currency,
    date
}

function email(value) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value.toLowerCase());
}

function phone(value) {
    return /^[0-9]*$/.test(value) && /^[0-9]{9,15}$/.test(value)
}

function name(value, isAllowSpace = true, minChar = 1, maxChar = '') {
    let regex = new RegExp(`^[a-zA-Z${isAllowSpace ? ' ' : ''}]{${minChar},${maxChar}}$`)
    return regex.test(value)
}

function loginID(value) {
    const re = /^[a-zA-Z0-9]{4,50}\S*$/;
    return re.test(value);
}

function password(value) {
    const re = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/;
    return re.test(value);
}

function fullName(value) {
    const re = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\\s]/;
    return re.test(value);
}

function positiveIntegerNumber(value) {
    return (/^[0-9]\d*$/).test(value);
}

function pin(value) {
    return (/^[0-9]{1,8}$/).test(value);
}

function currency(value, decimalSeparator = '.', decimalCount = 3) {
    let regex = new RegExp(`^\\d+(\\${decimalSeparator}\\d{0,${decimalCount}})?$`)
    return regex.test(value)
}

function date(value, separator = '/') {
    let regex = new RegExp(`^[0-9${separator}]+$`)
    return regex.test(value)
}